module.exports = __webpack_public_path__ + "static/media/en-US.0e2110ce.png";